import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { RootState } from "@store/store";
import { setOpen } from "@store/sessionTimedOutDialogSlice";
import AlertDialog from "@components/AlertDialog";

const SessionTimedOutDialog: FC = () => {
  const open = useSelector(
    (state: RootState) => state.sessionTimedOutDialog.open,
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(setOpen(false));
  };

  return (
    <AlertDialog
      open={open}
      onClose={onClose}
      title={t("sessionTimedOutDialog.title")}
      buttonTitle={t("sessionTimedOutDialog.confirmButton")}
    />
  );
};

export default SessionTimedOutDialog;
